export const oktaConfig = {
  clientId: '0oa2kix7571tnOvnr0h8',
  issuer: 'https://access-dev.dev.travelers.com/oauth2/aus2kix2uhyNzham80h8',
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  disableHttpsCheck: 'development',
  audience: 'Policy_Compliance_Viewer'
};
